import { css } from 'styled-components';

export const typography = css`
  .hl1 {
    font-size: 35px;
    line-height: 1.43;
    letter-spacing: 0.25px;
  }
  .hl2 {
    font-size: 25px;
    line-height: 1.6;
  }
  .hl3 {
    font-size: 21px;
    line-height: 1.67;
    letter-spacing: 0.25px;
  }
  .hl4 {
    font-size: 17px;
    font-weight: 800;
    line-height: 1.76;
    letter-spacing: 0.47px;
  }
  .sub_title {
    font-size: 15px;
    font-weight: 600;
    line-height: 1.67;
    letter-spacing: 0.5px;
  }
  .body_text {
    font-size: 15px;
    line-height: 1.67;
    letter-spacing: 0.25px;
  }
  .link_text {
    font-size: 15px;
    line-height: 1.67;
    letter-spacing: 0.25px;
    text-decoration: underline;
  }
  .button_text {
    font-size: 12px;
    font-weight: 600;
    line-height: 1.67;
    letter-spacing: 1.25px;
  }
  .overline {
    font-size: 12px;
    font-weight: 600;
    line-height: 1.67;
    letter-spacing: 1.25px;
  }
  .caption_text {
    font-size: 12px;
    line-height: 1.67;
    letter-spacing: 0.25px;
  }
`;
